import { render, staticRenderFns } from "./CMAddBankAccount.vue?vue&type=template&id=64f32e5a&"
import script from "./CMAddBankAccount.vue?vue&type=script&lang=js&"
export * from "./CMAddBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f32e5a')) {
      api.createRecord('64f32e5a', component.options)
    } else {
      api.reload('64f32e5a', component.options)
    }
    module.hot.accept("./CMAddBankAccount.vue?vue&type=template&id=64f32e5a&", function () {
      api.rerender('64f32e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bankAccounts/CMAddBankAccount.vue"
export default component.exports